// extracted by mini-css-extract-plugin
module.exports = {"side":"BtnPriceSide_side__23seW"};